/* eslint-disable max-len */
import faq_message from "./message_faq_fr.js";
import privacy_message from "./message_privacy_fr.js";

export default {
  error: {
    apicall: 'Something went wrong on api server!',
    UserNotFoundException: 'User does not exist.',
    NotAuthorizedException: 'Incorrect username or password.',
    ChangePasswordNotAuthorizedException: 'Old password incorrect.',
    LimitExceededException: 'Attempt limit exceeded, please try after some time.',
    UsernameExistsException: 'An account with the given email already exists.',
    InvalidParameterExceptionPassword: 'Password did not conform with policy: Password must have a length greater than or equal to 8.',
    InvalidPasswordExceptionLong: 'Password did not conform with policy: Password not long enough.',
    InvalidPasswordExceptionLower: 'Password did not conform with policy: Password must have lowercase characters.',
    InvalidPasswordExceptionUpper: 'Password did not conform with policy: Password must have uppercase characters.',
    InvalidPasswordExceptionNumeric: 'Password did not conform with policy: Password must have numeric characters.',
    InvalidPasswordExceptionSymbol: 'Password did not conform with policy: Password must contain at least one of the above special characters.',
    similar: 'A user with the same name and date of birth already exists. Please enter a comment to differentiate it.',
    alreadyAssignedImei: 'IMEI allready assigned to a driver.',
    NetworkingError: 'Hmm ... it seems like you are no longer connected to the internet.',
  },
  accountMenu: {
    settings: 'Change password',
    logout: 'Logout',
    language: 'Language',
    languageFr: 'Français',
    languageNl: 'Nederlands',
    languageDe: 'Deutsch',
    languageEn: 'English',
  },
  login: {
    welcome1: 'Welcome to the BRAKE program "Behaviour Recording and Assessment for RisKs Education".',
    welcome2: 'Please login to access your data.',
    email: 'Email',
    emailPlaceholder: 'Email Address',
    password: 'Password',
    passwordPlaceholder: 'Password',
    rememberMe: 'Remember Me',
    forgottenPassword: 'Forgot password ?',
    connect: 'Log in',
    connectBussy: 'Logging in…',
    definePassword: 'Change your password',
    instructions: {
      title: 'Your new password must include at least:',
      characters: 'characters',
      uppercase: 'uppercase letter',
      number: 'number',
      symbol: 'special character',
    },
    definePasswordButton: 'Change password',
    definePasswordButtonBussy: 'Change password…',
  },
  signup: {
    emailLabel: 'Email',
    emailPlaceholder: 'Email address',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Create a password',
    confirmPasswordLabel: 'Confirm password',
    confirmPasswordPlaceholder: 'Confirm password',
    confirmationCodeLabel: 'Verification Code',
    confirmationCodePlaceholder: 'Enter verification code',
    confirmationCodeHelp: 'Please check your email for the code.',
    registerButton: 'Sign up',
    registerBussy: 'Signing up…',
    allreadyAccountQuestion: 'Already have a VIAS BRAKE account?',
    connectHere: 'Log in here',
    oldPasswordPlaceholder: 'Please enter your old password.',
    oldPasswordLabel: 'Old password',
  },
  forgot: {
    reinitPassword: 'Reset password',
    mailsent: 'Mail sent',
    anEmailHasBeenSent: 'An email has been sent.',
  },
  menu: {
    title: {
      driversShort: 'Drivers',
      drivers: 'Assigned Drivers',
      users: 'Admin Dashboard',
      calendar: 'Calendar',
      contested: 'Contested',
    },
  },
  adminDashboard: {
    tabs: {
      drivers: 'Drivers',
      psychologists: 'Psychologists',
      admins: 'Admins',
    },
    users: {
      firstName: 'First name',
      lastName: 'Last name',
      birthdate: 'Birthdate',
      email: 'Email',
      comment: 'Comment',
      search: 'Search',
      new: 'New',
      edit: 'Edit',
      delete: 'Delete',
      confirmDeleteTitle: 'Are you sure you want to delete?',
      deleteOk: 'Confirm',
      deleteCancel: 'Cancel',
      clickEnterComment: 'Enter a comment.',
    },
    drivers: {
      birthdate: 'Birthdate',
      psychologist: 'Psychologist',
      imei: 'IMEI',
    },
    psychologist: {
      assigned: 'No of drivers assigned',
      drivers: 'driver(s)',
    },
  },
  driverActions: {
    tabs: {
      calendar: 'Calendar',
      stats: 'Statistics',
      errorManagement: 'Contested speedings',
      followUp: 'Objectives and follow up',
    },
  },
  calendar: {
    event: {
      plugged: 'Device plugged',
      unplugged: 'Device unplugged',
    },
    messages: {
      date: 'Date',
      time: 'Time',
      event: 'Event',
      allDay: 'all day',
      week: 'week',
      work_week: 'work week',
      day: 'day',
      month: 'month',
      previous: 'back',
      next: 'next',
      yesterday: 'yesterday',
      tomorrow: 'tomorrow',
      today: 'today',
      agenda: 'agenda',
      more: 'more',
    },
  },
  driverSelection: {
    name: 'Name',
    birthdate: 'Birthdate',
    lastConsultation: 'Last consultation',
    disconnected: 'Disconnected',
    constested: 'Contested',
    speeding: 'Speeding',
  },
  contested: {
    date: 'Date',
    driver: 'Driver',
    location: 'Location',
    action: 'Action',
    errorType: 'Error type',
    errorReason: 'Justification',
  },
  faq:{
    faq_message
  },
  privacy:{
    privacy_message
  },
  journeyDetails: {
    indexTitle: 'Journey {index} on {total}',
    speeding: 'Speed overruns',
    severityTitle: 'Severity',
    severity: {
      noOverSpeed: 'No overspeed',
      small: 'Small',
      medium: 'Average',
      large: 'Serious',
      xlarge: 'Grave',
    },
    speed: 'Speed',
    limit: 'Limit',
    time: 'Time',
    duration: 'Duration of the segment',
    street: 'Adress',
    gps: 'GPS',
    reportError: 'Report error',
    acceptError: 'Accept',
    rejectError: 'Reject',
    overspeed: 'Excess speed',
    parameter: {
      start: 'Departure time',
      end: 'Arrival time',
      distance: 'Total distance',
      avgSpeed: 'Average speed',
      maxSpeed: 'Max speed',
    },
    itemsSelected: '{value, plural, one {item selected} other {items selected}}',
  },
  contestDialog: {
    title: 'Indicate an error',
    errorType: 'Error type',
    selectErrorType: 'Select error type',
    errorTypes: {
      mapmatching: 'Wrong map matching',
      cartography: 'Cartographic error',
      speedlimit: 'Wrong speed limit',
      other: 'Other',
    },
    reason: 'Justification',
    forValidation: 'For validation',
    retour: 'Back',
  },
  stats: {
    period: {
      overall: 'All',
      today: 'Today',
      yesterday: 'Yesterday',
      currentWeek: 'Current week',
      lastWeek: 'Last week',
      currentMonth: 'Current month',
      lastMonth: 'Last month',
    },
    behaviour: {
      accelerations: 'Abrupt accelerations',
      brakings: 'Hard brakings',
    },
    grouping: {
      dayly: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      dayOfWeek: 'Days of the week',
      hourOfDay: 'Hours of the day',
      groupOfHourOfDay: 'Grouped hours of the day',
      limit: 'By speed limit',
    },
    charts: {
      numberOfOverspeeds: 'Number of overspeeds',
      numberOfEvents: 'Number of events',
      totalOverspeeds: {
        title: 'Total overspeed',
      },
      overspeedsBySeverity: {
        title: 'Total seriousness',
      },
      totalOverspeedsBySeverity: {
        title: 'Total seriousness / period',
      },
      behaviourChart: {
        title: 'Braking / accelerations',
      },
    },
  },
  followUp: {
    buttons: {
      new: 'New',
      save: 'Save',
      cancel: 'Cancel',
    },
    comment: 'Comments',
    commentPlaceholder: 'Add any comments about the driver here.',
    objective: 'Obectives',
    objectivePlaceholder: 'Add the driver objectives here.',
  },
  'react-intl-formatted-duration': {
    duration: '{value} {unit}',
    longFormatting: '{minutes} {seconds}',
    timerFormatting: '{minutes}:{seconds}',
    daysUnit: '{value, plural, one {day} other {days}}',
    hoursUnit: '{value, plural, one {hour} other {hours}}',
    minutesUnit: '{value, plural, one {minute} other {minutes}}',
    secondsUnit: '{value, plural, one {second} other {seconds}}',
  },
};



// WEBPACK FOOTER //
// ./src/messages_en.js